import { render, staticRenderFns } from "./VueOverlay.vue?vue&type=template&id=056d41ab&scoped=true&"
import script from "./VueOverlay.vue?vue&type=script&lang=js&"
export * from "./VueOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VueOverlay.vue?vue&type=style&index=0&id=056d41ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056d41ab",
  null
  
)

export default component.exports